import z from 'zod';
import { responseBaseSchema } from '../shared.types';
import { idNameSchema } from '../bulkPushdown/bulkPushdown.types';

// ---- Bulk Update Attribute Filters ----

export const taskTagStyleSchema = z.object({
    backgroundColor: z.string(),
    color: z.string(),
});

export const taskTagOptionSchema = idNameSchema.extend({
    styles: taskTagStyleSchema.optional(),
});

export const bulkUpdateAttributeFiltersResponseSchema = z.object({
    ...responseBaseSchema.shape,
    departments: z.array(idNameSchema),
    baselineJobTitles: z.array(idNameSchema),
    communities: z.array(idNameSchema),
    phases: z.array(idNameSchema),
    tags: z.array(taskTagOptionSchema),
});

// ---- Bulk Update Attributes ----

export const bulkUpdateAttributesRequestSchema = z.object({
    baselineTaskIds: z.array(z.number().int()),
    trickleDown: z.boolean(),
    departmentId: z.number().int().nullable().optional(),
    communityId: z.number().int().nullable().optional(),
    jobTitleId: z.number().int().nullable().optional(),
    phaseId: z.number().int().nullable().optional(),
    taskTagIds: z.array(z.string()).optional(),
    isMilestone: z.enum(['true', 'false']).nullable(),
});

export const bulkUpdateAttributesResponseSchema = responseBaseSchema;

// ---- Type Exports ----

export type TaskTagStyle = z.infer<typeof taskTagStyleSchema>;
export type TaskTagOption = z.infer<typeof taskTagOptionSchema>;
export type BulkUpdateAttributeFiltersResponse = z.infer<typeof bulkUpdateAttributeFiltersResponseSchema>;
export type BulkUpdateAttributesRequest = z.infer<typeof bulkUpdateAttributesRequestSchema>;
export type BulkUpdateAttributesResponse = z.infer<typeof bulkUpdateAttributesResponseSchema>;
